// SVGRenderer.js
import React from "react";
import { SVGIcons } from "./SVGIcons";
import { availableSection } from "../../../TemplateConfig";

const SectionIcon = ({ incomingSectionId }) => {
  // Find the section that matches the incomingSectionId
  const sectionData = availableSection.find(
    (section) => section.sectionId === incomingSectionId
  );

  // If a matching section is found, use its font_class, otherwise default to a generic class
  const fontClass = sectionData?.font_class || "fa fa-certificate";

  return (
    <i
      className={`${fontClass} mr-2`} // Replace the class with the matching font_class
      aria-hidden="true"
    ></i>
  );
};

const SVGRenderer = ({
  iconName,
  primaryColor,
  secondaryColor,
  originalSecondaryColor,
  size,
  sectionId,
}) => {
  const increaseSizeBypx = (size) => {
    // Parse the numerical value from the string and add 5
    const newSize = parseInt(size, 10) + 6;
    // Return the new size with 'px' appended
    return `${newSize}px`;
  };

  const capitalizeFirstLetter = (name) =>
    name.charAt(0).toUpperCase() + name.slice(1);

  // Convert iconName to match the format in SVGIcons
  const formattedIconName = capitalizeFirstLetter(iconName);
  const IconComponent = SVGIcons[formattedIconName];

  if (!IconComponent) {
    return (
      <span
        style={{
          fontSize: size,
          // marginTop: "auto",
          color: originalSecondaryColor,
        }}
      >
        {" "}
        <SectionIcon incomingSectionId={sectionId} />
      </span>
    );
    // return null; // Return null if the icon doesn't exist
  }

  return (
    <div style={{ marginRight: "10px" }}>
      <IconComponent
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        size={increaseSizeBypx(size)}
      />
    </div>
  );
};

export default SVGRenderer;
